import { MainStore } from "core/store";
import React, { useContext, useEffect, useState } from "react";
import FavoriteCard from "./favorite-card";
import { Divider, Empty, Image, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import BGImage from "../../../assets/images/png/bg.png";
import api from "api";
import Loading from "components/loading";

export default function Favorite() {
  const { userData, setUserData } = useContext(MainStore);
  const [isLoading, setIsLoading] = useState(false);
  const [favoriteList, setFavoriteList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [isSearch, setIsSearch] = useState(false);

  useEffect(() => {
    getFavorite();
  }, []);

  async function getFavorite() {
    setIsLoading(true);
    try {
      const { data } = await api.favoriteApi.getFavoriteByUserId(userData.id);
      setFavoriteList(data.data);
    } catch (error) {
      console.error("getFavorite", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function onClickAddFavorite(id) {
    setIsLoading(true);
    const temp = { ...userData };
    temp.favorite.push(id);

    try {
      const { data } = await api.favoriteApi.updateFavorite(userData.id, {
        favorite: temp.favorite,
      });
      if (data) setUserData(temp);
    } catch (error) {
      console.log("onClickAddFavorite", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function onClickRemoveFavorite(id) {
    setIsLoading(true);
    const temp = { ...userData };
    const find_fav_index = temp.favorite.findIndex(
      (fav) => parseInt(fav) === parseInt(id)
    );
    if (find_fav_index !== -1) {
      temp.favorite.splice(find_fav_index, 1);
    }

    try {
      const { data } = await api.favoriteApi.updateFavorite(userData.id, {
        favorite: temp.favorite,
      });
      if (data) setUserData(temp);
    } catch (error) {
      console.log("onClickRemoveFavorite", error);
    } finally {
      setIsLoading(false);
    }
  }

  function onSearch(value) {
    setIsSearch(value ? true : false);
    const search_lish = favoriteList.filter(
      (fav) =>
        fav?.display_name?.includes(value) ||
        fav?.caddy_number?.toString()?.includes(value)
    );
    setSearchList(search_lish);
  }

  return (
    <div className="search-caddy-container">
      <Loading visible={isLoading} />
      <div
        style={{
          padding: 25,
          fontWeight: "bold",
          fontSize: 24,
          position: "sticky",
          top: 0,
          left: 0,
          zIndex: 9,
          background: "white",
          boxShadow:
            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          borderBottomRightRadius: 30,
          borderBottomLeftRadius: 30,
        }}
      >
        <center>MY FAVORITE</center>
      </div>
      <div className="search-caddy-content" style={{ padding: "20px 40px" }}>
        <div>
          <h2 style={{ margin: 0 }}>รายการโปรดทั้งหมด</h2>
        </div>
        <Input
          onChange={(e) => onSearch(e.target.value)}
          prefix={<SearchOutlined />}
          style={{ borderRadius: 10 }}
          placeholder="ค้นหาชื่อ, หมายเลขแคดดี้"
        />
        <Divider style={{ margin: "5px 0px" }} />
        <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>
          {isSearch ? (
            searchList.length > 0 ? (
              searchList.map((favorite) => {
                const is_fav = userData.favorite.find(
                  (fav) => parseInt(fav) === parseInt(favorite.id)
                );
                return (
                  <FavoriteCard
                    onClickRemoveFavorite={onClickRemoveFavorite}
                    onClickAddFavorite={onClickAddFavorite}
                    is_fav={is_fav}
                    data={favorite}
                  />
                );
              })
            ) : (
              <Empty description="ไม่มีข้อมูลแคดดี้ที่ค้นหา" />
            )
          ) : favoriteList.length > 0 ? (
            favoriteList.map((favorite) => {
              const is_fav = userData.favorite.find(
                (fav) => parseInt(fav) === parseInt(favorite.id)
              );
              return (
                <FavoriteCard
                  onClickRemoveFavorite={onClickRemoveFavorite}
                  onClickAddFavorite={onClickAddFavorite}
                  is_fav={is_fav}
                  data={favorite}
                />
              );
            })
          ) : (
            <Empty description="ไม่มีข้อมูล Favorite แคดดี้ของคุณ" />
          )}
        </div>
      </div>

      <div
        style={{
          position: "fixed",
          zIndex: 0,
          bottom: 0,
          left: 0,
          opacity: 0.5,
        }}
      >
        <Image
          width="100%"
          height={150}
          preview={false}
          src={BGImage}
          style={{
            filter:
              "brightness(0) saturate(100%) invert(77%) sepia(67%) saturate(395%) hue-rotate(87deg) brightness(91%) contrast(85%)",
          }}
        />
      </div>
    </div>
  );
}
